import ErrorService from "@/services/error.service";
import TokenService from "@/services/token.service";
import { useAuthStore } from "@/store/auth.store";
import { useGeneralStore } from "@/store/general.store";

export default async (to, from, next) => {
  const authStore = useAuthStore();
  const generalStore = useGeneralStore();
  const permissions = generalStore.permissions;
  const modules = generalStore.modules;
  const loggedIn = TokenService.hasToken();

  // Set title
  if (to.meta && to.meta.title) {
    document.title = process.env.VUE_APP_TITLE + " • " + to.meta.title;
  } else {
    document.title = process.env.VUE_APP_TITLE;
  }

  // Check permissions
  function checkPermissions() {
    if (modules.PARTNERS != undefined && !modules.PARTNERS && to.name == "app.organizations.partners") {
      next({ name: "error", query: { message: "No permissions to view partners!" } });
    } else if (to.name == "app.organizations.users" && permissions.can_view_users != undefined && !permissions.can_view_users) {
      next({ name: "error", query: { message: "No permissions to view users!" } });
    } else if (to.name == "app.organizations.partners" && permissions.can_view_partners != undefined && !permissions.can_view_partners) {
      next({ name: "error", query: { message: "No permissions to view partners!" } });
    } else {
      next();
    }
  }

  // Get user profile and organizations
  if (to.meta.public) {
    next();
  } else if (loggedIn && !authStore.userProfile) {
    // Fetch user profile
    try {
      await authStore.getUserProfile();
      checkPermissions();
    } catch (error) {
      ErrorService.showError(error);
      next({ name: "error", params: { error } });
    }
  } else if (loggedIn && authStore.userProfile) {
    checkPermissions();
  } else {
    // authStore.logout();
    next({ name: "error", query: { message: "Not logged in!" } });
  }
};
